import FailedAttemptsLock from './FailedAttemptsLock';

export default FailedAttemptsLock;
